import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, RouterStateSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/login/login.service';

@Injectable()
export class AuthGuard implements CanLoad, CanActivate {
    constructor(private router: Router, private loginService: LoginService) {}

    checkAuthentication(path?: string): boolean {
        const loggedIn = this.loginService.isLoggedIn()
        if (!loggedIn) {
            this.loginService.handleLogin(`/${path}`);
        }
        return loggedIn;
    }

    canLoad(route: Route): boolean {
        return this.checkAuthentication(route.path);
    }

    canActivate(activatedRoute: ActivatedRouteSnapshot, routerState: RouterStateSnapshot): boolean {
        return this.checkAuthentication(routerState.url);
    }
}
